import { useEffect, useState } from "react";
// import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import {
  InputAdornment,
  Container,
  Stack,
  Typography,
  TextField,
  Grid,
  IconButton,
} from "@mui/material";
import Iconify from "../../../components/iconify";
import { LoadingButton } from "@mui/lab";
import { isEmpty } from "../../../utils/validator";
import ValidationError from "../../../components/validation-error-label";
import { useNavigate, useSearchParams } from "react-router-dom";
import { POST } from "../../../config/https";
import APIS from "../../../config/api";
import { toast } from "react-hot-toast";
import FullScreenLoader from "../../../components/full-screen-loader";
import Color from "../../../theme/color";

const StyledRoot = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

export default function ResetPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [isValidation, setIsValidation] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setErrors] = useState("");
  const [loader, setLoader] = useState(false);
  const [token, setToken] = useState("");
  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [confirmNewPassword, newPassword, isValidation, error]);

  useEffect(() => {
    let temp = searchParams.get("token");
    setToken(temp ? temp : "");
  }, []);
  const handleClick = async () => {
    setIsValidation(true);
    if (!validator()) return;
    setLoader(true);
    let tokenFinal = token.replace(/<\/$/, "");
    let params = {
      password: newPassword,
      token: tokenFinal,
    };
    if (tokenFinal) {
      await POST(APIS.RESET_PASSWORD, params)
        .then((res: any) => {
          if (res?.isSuccess) {
            toast.success("Your password has been successfully reset");
            navigate("/login", { replace: true });
          } else {
            const errorMessage = res.errors[0].toString();
            setErrors(errorMessage);
            validator();
          }
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          setLoader(false);
        });
    }
    setLoader(false);
  };
  const validator = () => {
    const errors: Record<string, string> = {};
    if (isEmpty(newPassword)) {
      errors.password = "Please enter a New Password";
    }

    if (isEmpty(confirmNewPassword)) {
      errors.confirmPassword = "Please enter a Confirm Password";
    }
    if (confirmNewPassword !== newPassword) {
      errors.confirmPassword = "Passwords do not match";
    } else if (error) {
      errors.confirmPassword = error;
    } else {
      delete errors.confirmPassword;
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      handleClick();
    }
  };
  return (
    <>
      <StyledRoot>
        <Container maxWidth="sm">
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Reset Your Password
            </Typography>
            <Stack direction="row" spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  style={{ marginTop: 10 }}
                  fullWidth
                  label="New Password"
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                  }}
                  type={showPassword ? "text" : "password"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyPress={handleKeyPress}
                  autoComplete="off"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          <Iconify
                            icon={
                              showPassword ? "eva:eye-fill" : "eva:eye-off-fill"
                            }
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <ValidationError formErrors={formErrors.password} />
                <TextField
                  style={{ marginTop: 10 }}
                  fullWidth
                  // name="password"
                  label="Confirm New Password"
                  value={confirmNewPassword}
                  onChange={(e) => {
                    setConfirmNewPassword(e.target.value);
                  }}
                  type={showPassword ? "text" : "password"}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyPress={handleKeyPress}
                  autoComplete="off"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          <Iconify
                            icon={
                              showPassword ? "eva:eye-fill" : "eva:eye-off-fill"
                            }
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <ValidationError formErrors={formErrors.confirmPassword} />
              </Grid>
            </Stack>

            <LoadingButton
              style={{
                width: 480,
                marginTop: 20,
                backgroundColor: Color.primary,
                fontSize: "17px",
              }}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              onClick={handleClick}
            >
              Submit
            </LoadingButton>
          </StyledContent>
          <FullScreenLoader open={loader} />
        </Container>
      </StyledRoot>
    </>
  );
}
